<template>
  <div class="team">
        <Modal
            title="提示"
            v-model="modals"
            class-name="modals"
        >
            <p>向该中心发起案例，需要提交加入申请，是否确定现在提交</p>
            <div slot="footer">
                <Button size="large" @click="modals = false">取消</Button>
                <Button size="large" @click="sendDiscuss">确定</Button>
            </div>
        </Modal>
    <div class="top">
      <div class="corner" v-if="this.IsJoin!==null" :style="{background:this.IsJoin == 'T' ? '#1890FF' : '#DED9BB'}">{{this.IsJoin == 'T' ?"已加入":"已申请"}}</div>
      <div class="left">
        <h2>
          {{ teamInfo.team }}
        </h2>
        <span class="span">{{ intro ? intro : "暂时没有介绍介~" }}</span>
        <br/>
        <Button @click="startDiscuss" type="primary" class="todiscuss" v-if="doctorList.length>0">发起案例讨论</Button>
      </div>
      <div class="right">
        <img src="../assets/u121.png" alt="0.0">
      </div>
    </div>
    <div class="bottom" style="padding-bottom: 40px">
      <Row style="width: 100%" v-if="doctorList.length>0">
        <Col
          span="8"
          style="margin-top: 69px; width: 33.3%; padding: 10px"
          v-for="(item, index) in doctorList"
          :key="item.label"
          ><div
            @mouseenter="hover(index, item)"
            @mouseleave="leave(index)"
            :class="`div-${index}`"
          >
            <Card
              style="width: 80%; min-height: 220px; margin: 0 auto"
              class="card"
            >
              <img
                v-if="item.ImgUrl"
                :src="item.ImgUrl"
                alt="图片找不到咧~"
                class="img"
                :class="`img-${index}`"
              />
              <img
              v-else
              src="../assets/baseImg.jpg"
              class="img"
              :class="`img-${index}`"
            />
              <!-- <div
              v-else
              onselectstart="return false;"
              title="该用户没有上传头像"
              style="
                position: absolute;
                top: -64px;
                left: calc(50% - 54px);
                width: 108px;
                height: 108px;
                border-radius: 50%;
                text-align:center;
                line-height:98px;
                border:1px solid #eee;
                color:#aaa;
                background:#fff;
              "
              :class="`img-${index}`"
            >✖﹏✖</div> -->
              <b
                style="
                  display: block;
                  margin-top: 39px;
                  color: #000;
                  font-size: 18px;
                "
                >{{ item.DocName }}</b
              >
              <p style="margin-top: 7px; color: #000; font-weight: 500">
                {{ item.DocPosition }}
              </p>
              <p style="color: #000; font-weight: 500">
                {{ item.HospitalName }}
              </p>
              <div
              v-if="item.Level == 'A' ? true : false"
                style="
                  position: absolute;
                  border-top: 1px solid #eee;
                  display:flex;
                  min-width: 100%;
                  max-width: 100%;
                  height: 58px;
                  left: 0;
                  bottom: 0;
                "
              >
                <Button class="tota" @click="startDiscussToTa1(item)" type="primary">向 Ta 发起案例讨论</Button>
                <Button class="lookdetail" @click="detail(item, index)" >查看详情</Button>
              </div>
              <div
              v-else
                style="
                  position: absolute;
                  border-top: 1px solid #eee;
                  display:flex;
                  min-width: 100%;
                  max-width: 100%;
                  height: 58px;
                  left: 0;
                  bottom: 0;
                "
              >
                <Button class="lookdetail1" @click="detail(item, index)" >查看详情</Button>
              </div>
            </Card>
          </div></Col
        >
      </Row>
      <Row v-else style="width:100%">
        <div style="width:100%;text-align:center;height:50px;line-height:50px;background:#fff;margin-top:20px">没有更多数据了~</div>
      </Row>
      <!-- -------------------------------------------Modal--------------------------------------------------------- -->
      <Modal v-model="modal" width="410px;" :styles="{top: '200px'}" class-name="modal">
        <!-- 模态框内容 -->
        <Row style="position:relative">
          <Col span="16" offset="4">
            <img
              v-if="docImg"
              :src="docImg"
              alt="图片找不到咧~"
              style="
                width: 108px;
                height: 108px;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: calc(50% - 59px);
              "
            />
            <img
              v-else
              src="../assets/baseImg.jpg"
              style="
                width: 108px;
                height: 108px; 
                border-radius: 50%;
                margin-top: 10px;
                margin-left: calc(50% - 59px);
              "
            />
          </Col>
          <!-- 姓名和职位----------------------------------------------------------- -->
          <Col span="16" offset="4" style="text-align: center"
            ><p
              style="
                display: inline;
                font-size: 20px;
                font-weight: 800;
                color: #000;
                text-align: center;
              "
            >
              {{ details.docName }}
            </p>
            <p
              style="
                margin-left: 5px;
                display: inline;
                font-size: 20px;
                font-weight: 800;
                color: #000;
              "
            >
              {{ docPosition }}
            </p>
          </Col>
          <!-- 团队----------------------------------------------------------- -->
          <Col span="16" offset="4" style="margin-top: 5px">
            <p style="text-align: center">
              {{ docTeam }}
            </p>
          </Col>
          <!-- 位置----------------------------------------------------------- -->
          <Col span="16" offset="4" style="margin-top: 15px">
            <Icon type="ios-pin-outline" size="20"></Icon>
            <p style="display: inline">{{ docLocation }}</p>
          </Col>
          <!-- 虚线----------------------------------------------------------- -->
          <Col span="16" offset="4" style="margin-top: 10px">
            <p style="width: 100%; position:absolute;left:0px;height: 0; border-top: 1px dashed #ccc"></p>
          </Col>
          <!-- 简介----------------------------------------------------------- -->
          <Col span="16" offset="4" style="margin-top: 25px">
            <p style="color:#000;font-weight:800">简介</p>
            <Input
              v-model="docSynopsis"
              readonly
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              placeholder=""
              style="background: #eee"
            />
          </Col>
          <!-- 擅长----------------------------------------------------------- -->
          <Col span="16" offset="4" style="margin-top: 20px">
            <p style="color:#000;font-weight:800">擅长</p>
            <Input
              v-model="docAdept"
              readonly
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              placeholder=""
              style="background: #eee"
            />
          </Col>
          <!-- 底部----------------------------------------------------------- -->
          <Col span="20" offset="2" style="margin-top: 20px;text-align:center">
            <img
              src="../assets/img1.png"
              alt="0.0"
              style="width: 24px; height: 24px; border-radius: 50%"
            />
              <p
                style="
                  display: inline-block;
                  max-width: 250px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  padding:0 10px
                "
                :title='docTeam'
              >
               {{ docTeam }}
              </p>
            <img
              src="../assets/img2.jpg"
              alt="0.0"
              style="width: 30px; height: 30px; border-radius: 50%"
            />
          </Col>
          <Col span="24" offset="0" style="width:100%;text-align:center;position:absolute;bottom:-70px">
            <!-- <Button @click="startDiscussToTa" type="primary" v-if="this.details.level == 'A' ? true : false">向 Ta 发起案例讨论</Button> -->
          </Col>
        </Row>
        <!-- 使用div盖住footer的上边框 -->
        <div
          style="
            height: 10px;
            background: #fff;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 80px;
          "
        ></div>
        <!-- 模态框脚部------------------------------------------------------------ -->
        <div slot="footer" style="height: 60px"></div>
      </Modal>
    </div>
  </div>
</template>
<script>
import Request from "../utils/request";
import config from "../config/index.js";
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  Icon,
  Input,
  Poptip,
  Spin,
} from "view-design";
export default {
  components: {
    Row,
    Col,
    Card,
    Button,
    Modal,
    Icon,
    Input,
    Poptip,
    Spin,
  },
  data() {
    return {
      modals:false,//发起申请的模态框
      teamInfo:{
        team:"-",
        teamID:"",
        type:1,
        IsJoin:"",
      },
      intro:"",
      modal: false,
      // -------------------------------------
      // 查看详情里面现实的内容
      docImg: "",
      docPosition: "",
      docLocation: "",
      //介绍
      docSynopsis: "",
      //擅长
      docAdept: "",
      docTeam: "",
      details:{
        level:"",//医生等级
        //团队名称
        team:"",
        //团队ID
        teamID:"",
        docName: "",
        docID:"",
        docUserjid:"",
        type:2,
        IsJoin:"",//是否发起申请
      },
      // -------------------------------------
      doctorList: [],
      IsJoin:"",
    };
  },
  created() {
    console.log(this.$store.state.info)
    this.teamInfo.team = this.$store.state.info.team
    this.teamInfo.teamID = this.$store.state.info.teamID
    this.teamInfo.IsJoin = this.$store.state.info.isJoin
    this.intro = this.$store.state.info.intro
    this.IsJoin = this.$store.state.info.isJoin
    this.$emit("funChangeTitle", "专家团队信息", "");
    this.getDatas();
  },
  mounted() {
  },
  methods: {
    //============请求接口========================================================
    //分页获取医生列表
    getDatas(){
      Request.getRequest(config.SXG_baseUrl + "/api/casemanager/GetDocListByPosition", {
        CenterID:this.teamInfo.teamID
      }).then((res)=>{
        if (res.code == 200) {
          // console.log(res);
          if (res.data.length > 0) {
            this.doctorList = res.data;
            this.teamInfo.team = res.data[0].CenterName
          }
        }
      })
    },
    // getDatas() {
    //   Request.getRequest(config.SXG_baseUrl + "/api/currency/GetRecordByPage", {
    //     pageSize: "13",
    //     pageNum: "1",
    //     tablename: "DocList",
    //     searchkey1:"DocType",
    //     searchvalue1:"中心",
    //     searchkey3: "CenterID",
    //     searchvalue3: this.teamInfo.teamID,
    //   }).then((res) => {
    //     if (res.code == 200) {
    //       // console.log(res);
    //       if (res.data.Record.length > 0) {
    //         this.doctorList = res.data.Record;
    //         this.teamInfo.team = res.data.Record[0].CenterName
    //       }
    //     }
    //   });
    // },
    //============请求接口========================================================
    //发起案例讨论（固定团队）
    startDiscuss(){
      if(this.IsJoin == null){
                /* 如果还未申请 就弹出对话框 选择是否发起申请 */
                this.modals = true
            }else{
                if(this.IsJoin == 'T'){
                /* 如果申请过 并且 通过的话 存一下变量跳转页面*/
                    this.$store.commit({
                      type:'edit',
                      payload:{
                          ...this.teamInfo
                      }
                    })
                    this.$router.push("/HomePage/NewCase")
                }else if(this.IsJoin == 'F'){
                    /* 不能申请了*/
                    this.$Message['info']({
                        background: true,
                        content: '您已向团队发起申请，请耐心等待审核'
                    })
                }
            }
      // console.log(this.teamInfo)
      
    },
    startDiscussToTa(){
      // console.log(this.details)
      this.$store.commit({
        type:'edit',
        payload:{
            ...this.details
        }
      })
      this.$router.push("/HomePage/NewCase")
    },
    detail(item, index) {
      // console.log(item);
      this.docImg = item.ImgUrl;
      this.docPosition = item.DocPosition;
      this.docLocation = item.HospitalName;
      this.docSynopsis = item.Introduce;
      this.docAdept = item.Skill;
      this.docTeam = item.CenterName;
      this.details.docName = item.DocName;
      this.details.docUserjid = item.UserJid;
      this.details.docID = item.ID
      this.details.team = item.CenterName;
      this.details.teamID = item.CenterID;
      this.details.level = item.Level;
      this.modal = true;
    },
    startDiscussToTa1(item){
      this.details.docName = item.DocName;
      this.details.docUserjid = item.UserJid;
      this.details.docID = item.ID
      this.details.team = item.CenterName;
      this.details.teamID = item.CenterID;
      this.details.level = item.Level;
      this.details.IsJoin = this.$store.state.info.isJoin
      if(this.IsJoin == null){
                /* 如果还未申请 就弹出对话框 选择是否发起申请 */
                this.modals = true
            }else{
                if(this.IsJoin == 'T'){
                /* 如果申请过 并且 通过的话 存一下变量跳转页面*/
                    this.$store.commit({
                      type:'edit',
                      payload:{
                        ...this.details
                      }
                    })
                    this.$router.push("/HomePage/NewCase")
                }else if(this.IsJoin == 'F'){
                    /* 不能申请了*/
                    this.$Message['info']({
                        background: true,
                        content: '您已向团队发起申请，请耐心等待审核'
                    })
                }
            }
    },
    /* -----------------------------------获取团队列表------------------------------------------ */
    hover(index, item) {
      const img = document.querySelector(`.img-${index}`);
      img.classList.add("img-shadow");
      //   console.log(node);
    },
    leave(index) {
      const img = document.querySelector(`.img-${index}`);
      img.classList.remove("img-shadow");
    },

    //发起讨论
        sendDiscuss(){
            this.modal = false
            Request.postRequest(config.SXG_baseUrl+"/api/docmanager/SaveDocCenter",{
                    tablename:"DocCenter",//表名 DocCenter
                    CenterName:this.$store.state.info.centerName,
                    CenterID:this.$store.state.info.centerID,
                    UserJid:JSON.parse(window.localStorage.getItem('Role')).UserJid,
                    DocName:JSON.parse(window.localStorage.getItem('Role')).DocName,
                    DLID:JSON.parse(window.localStorage.getItem('Role')).ID,//医生表（Role）的 ID
                    Sex:JSON.parse(window.localStorage.getItem('Role')).Sex,
                    Cellphone:JSON.parse(window.localStorage.getItem('Role')).Cellphone,
                    Age:JSON.parse(window.localStorage.getItem('Role')).Age,
                    HospitalName:JSON.parse(window.localStorage.getItem('Role')).HospitalName,
                    DepartmentName:JSON.parse(window.localStorage.getItem('Role')).DepartmentName,
                }).then((res)=>{
                    if(res.code == 200){
                        // console.log(1)
                        this.$Message.info("成功！")
                        this.$router.go(0)
                    }
                })
        },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="less">
.team {
  img {
    -webkit-user-drag: none;
  }
  height: 100%;
  .top{
    width: 100%;
    min-width:1200px;
    background-color: transparent;
    padding: 0px 20px;
    border-bottom: 2px solid #eee;
    .corner{
      width: 70px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      font-weight: 500;
      letter-spacing: 2px;
      border-bottom-left-radius: 15px;
      transition: all 0.3s;
            }
    .left{
      // width: 800px;
      float: left;
      padding-bottom: 20px;
      h2{
        color: #000;
        margin-bottom: 20px;
        margin-top:40px;
      }
    .span{
        min-width:600px;
        width:800px;
        height:100%;
        min-height: 63px;
        display:inline-block;
        color:#000;
        word-wrap: break-word;
      }
    .todiscuss{
        float:left;
        margin-top:25px;
      }
    }
    .right{
      float: right;
      img{
        margin-top:5px
      }
    }
  }
  .bottom {
    .lookdetail{
      border: none; 
      min-width: 55%; 
      height: 100%;
      background:RGB(247,249,250);
    }
    .lookdetail1{
      border: none; 
      min-width: 100%; 
      height: 100%;
      background:RGB(247,249,250);
    }
    .tota{
      border: none;
      border-radius: 0;
      min-width: 45%;
      height: 100%;
    }
    width: 100%;
    min-height: calc(100% - 195px);
    background-color: rgba(240, 242, 245, 1);
    display: flex;
    .card {
      position: relative;
      text-align: center;
      .img {
        width: 108px;
        height: 108px;
        border-radius: 50%;
        position: absolute;
        top: -64px;
        left: calc(50% - 54px);
        box-shadow: 0px 0px 2px #aaa;
      }
      .img-shadow {
        width: 108px;
        height: 108px;
        border-radius: 50%;
        position: absolute;
        top: -64px;
        left: calc(50% - 54px);
        box-shadow: 0px 0px 7px #aaa;
        transition: 0.3s all;
      }
    }
    .ivu-modal-footer {
      border-top: 0px solid #aaa;
    }
  }
  .modals{
            display: flex;
            align-items: start;
            justify-content: center;
            top:200px;
            .ivu-modal{
                width: 350px!important;
            }
            .ivu-modal-header-inner{
                text-align: center;
                font-weight: 800;
                font-family: "Microsoft Yahei";
            }
            .ivu-modal-header{
                border-bottom: none;
            }
            .ivu-modal-body{
                padding:8px 50px 16px 50px;
                word-break:break-all;
            }
            .ivu-modal-footer{
                padding: 0;
                div{
                    text-align: center;
                    // border-top: none;
                    display: flex;
                    padding: 0;
                }
                .ivu-btn{
                    width: 50%;
                    height: 50px;
                    border-top-left-radius: 0px;
                    border-top-right-radius: 0px;
                    background: #fff;
                    border: none;
                    color: #6F78F7;
                    font-size: 16px;
                }
                .ivu-btn:nth-child(1){
                    border-right: 1px solid #eee;
                }
            }
            .ivu-icon-ios-close:before{
                display: none;
            }
        }
}
</style>